import { createBreadcrumbTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Breadcrumb Component Configuration
 * Navigation breadcrumbs
 */
export function createBreadcrumb(s: SemanticTokens) {
  const breadcrumbTokens = createBreadcrumbTokens(s);
  return {
  root: {
    padding: '0',
    background: 'transparent',
    gap: breadcrumbTokens.base.gap,
  },
  item: {
    color: breadcrumbTokens.fg,
    hoverColor: breadcrumbTokens.fgHover,
    gap: breadcrumbTokens.base.itemGap,
    icon: {
      color: breadcrumbTokens.iconFg,
      hoverColor: breadcrumbTokens.iconFgHover,
    },
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none',
    },
  },
  separator: {
    color: breadcrumbTokens.separatorFg,
  },
  colorScheme: {
    light: {
      root: { background: 'transparent' },
      item: {
        color: breadcrumbTokens.fg,
        hoverColor: breadcrumbTokens.fgHover,
        icon: {
          color: breadcrumbTokens.iconFg,
          hoverColor: breadcrumbTokens.iconFgHover,
        },
      },
      separator: { color: breadcrumbTokens.separatorFg },
    },
  },
  css: () => `
    .p-breadcrumb {
      font-size: ${breadcrumbTokens.base.fontSize};
      line-height: ${breadcrumbTokens.base.lineHeight};
    }

    .p-breadcrumb .p-breadcrumb-item-link,
    .p-breadcrumb-item-label {
      font-size: ${breadcrumbTokens.base.fontSize};
      line-height: ${breadcrumbTokens.base.lineHeight};
    }

    .p-breadcrumb .p-breadcrumb-separator svg {
      font-size: ${breadcrumbTokens.base.iconSize};
      width: ${breadcrumbTokens.base.iconSize};
      height: ${breadcrumbTokens.base.iconSize};
    }

    .p-breadcrumb .p-breadcrumb-item:last-child .p-breadcrumb-item-link,
    .p-breadcrumb .p-breadcrumb-item:last-child .p-breadcrumb-item-label {
      font-weight: ${breadcrumbTokens.base.lastItemFontWeight};
    }
  `,
  };
}
export const breadcrumb = createBreadcrumb(SEMANTIC);